import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=62147f0e&"
import script from "./ServiceList.vue?vue&type=script&lang=js&"
export * from "./ServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62147f0e')) {
      api.createRecord('62147f0e', component.options)
    } else {
      api.reload('62147f0e', component.options)
    }
    module.hot.accept("./ServiceList.vue?vue&type=template&id=62147f0e&", function () {
      api.rerender('62147f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/service/ServiceList.vue"
export default component.exports